export const imageCards = () => {
    document.querySelectorAll('.image-card').forEach(card => {
        const content = card.querySelector<HTMLElement>('.image-card__content');
        const toggle = card.querySelector<HTMLButtonElement>('.image-card__toggle');
        if (toggle && content) {
            toggle.addEventListener('click', () => {
                const expanded = toggle.getAttribute('aria-expanded') !== 'true';
                toggle.setAttribute('aria-expanded', String(expanded));
                content.inert = !expanded;
            });
        }
    });
};
